import React, { useEffect, useState } from "react";
import AreaChart from "./chart/AreaChart";
import DashboardTripCharts from "./chart/DashboardTripCharts";
import DashboardAnalyticsPanels from "./chart/DashboardAnalyticsPanels";
import { tripDashboardReportApiCall } from "../../Api/api";
import { useNavigate } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";
import CustomTable from "./CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { ROLES } from "../../constansts/Roles";
import { listFleetExpratioRecordAsync } from "../../redux/features/fleetMasterExpirationSlice";
import { backdropLoadingAction } from "../../redux/features/helperSlice";
import { currentOpenTripListAsync } from "../../redux/features/dashboard-master/currentOpenTripSlice";
import { unassignedTripVehiclesAsync } from "../../redux/features/dashboard-master/unassignedTripVehiclesSlice";
import { fleetEMIReportAsync } from "../../redux/features/reportSlice";
import moment from "moment";
import Button from "@mui/material/Button";
import { IoMdDownload } from "react-icons/io";
import * as XLSX from "xlsx";
import { data } from "jquery";

const Body = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const [range, setRange] = useState("weekly");
   const [reportData, setReportData] = useState(null);
   const [expiration_records, setExpirationRecords] = useState([]);
   const [currentOpenTrip, setCurrentOpenTrip] = useState([]);
   const [unassignedTripRecords, setUnassignedTripRecords] = useState([]);
   const [emiData, setEmiData] = useState([]);

   const fleetMasterExpirationList = useSelector(
      (state) => state.fleetMasterExpiration?.dataList,
   );
   const currentOpenTripList = useSelector((state) => state.currentOpenTripList?.data);
   const unassignedTripVehiclesList = useSelector(
      (state) => state.unassignedTripVehiclesList?.data,
   );

   const role_id = useSelector((state) => state?.auth?.user?.data?.user?.role_id);
   const todayDate = new Date().toISOString().split("T")[0];

   const getDashboardReport = async () => {
      try {
         const res = await tripDashboardReportApiCall(range);
         setReportData(res?.data);
      } catch (error) {}
   };

   useEffect(() => {
      getDashboardReport();
   }, [range]);

   useEffect(() => {
      if (fleetMasterExpirationList) {
         setExpirationRecords(fleetMasterExpirationList);
      }
   }, [fleetMasterExpirationList]);

   useEffect(() => {
      if (currentOpenTripList) {
         const records = Object.values(currentOpenTripList);
         // Sort by start_date in descending order (latest first)
         const sortedRecords = records.sort((a, b) => {
            const dateA = new Date(a.start_date);
            const dateB = new Date(b.start_date);
            return dateB - dateA; // Descending order (latest first)
         });
         setCurrentOpenTrip(sortedRecords);
      }
   }, [currentOpenTripList]);

   useEffect(() => {
      if (unassignedTripVehiclesList) {
         const records = Object.values(unassignedTripVehiclesList);
         setUnassignedTripRecords(records);
      }
   }, [unassignedTripVehiclesList]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listFleetExpratioRecordAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         }),
      );
   }, []);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         currentOpenTripListAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         }),
      );
   }, []);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         unassignedTripVehiclesAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         }),
      );
   }, []);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      const filter_params = {
         model_id: 11,
         action_id: 3,
         from_date: moment().startOf("month").format("YYYY-MM-DD"),
         to_date: moment().endOf("month").format("YYYY-MM-DD"),
      };
      dispatch(
         fleetEMIReportAsync({
            data: filter_params,
            done: (report) => {
               dispatch(backdropLoadingAction(false));
               if (report) {
                  const transformed = report.flat().filter(Boolean);
                  setEmiData(transformed);
               } else {
                  setEmiData([]);
               }
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
               setEmiData([]);
            },
         })
      );
   }, [dispatch]);

   const truncateText = (value, max = 16) => {
      if (!value) return "—";
      const text = String(value);
      return text.length > max ? `${text.slice(0, max)}...` : text;
   };

   const formatDisplayDate = (dateStr) => {
      if (!dateStr) return "—";
      const date = new Date(dateStr);
      if (Number.isNaN(date.getTime())) return dateStr;
      return date.toLocaleDateString("en-GB", {
         day: "2-digit",
         month: "short",
         year: "numeric",
      });
   };

   const getDocBadgeTone = (docName = "") => {
      const name = String(docName).toLowerCase();
      if (
         name.includes("national permit") ||
         name.includes("permit") ||
         name.includes("insurance")
      ) {
         return "orange";
      }
      return "blue";
   };

   const getTrendClass = (changeType) => {
      if (changeType === "increase") return "oil-stat-card__trend--up";
      if (changeType === "decrease") return "oil-stat-card__trend--down";
      return "oil-stat-card__trend--flat";
   };

   const getTrendIcon = (changeType) => {
      if (changeType === "increase") return <i className="fas fa-caret-up" />;
      if (changeType === "decrease") return <i className="fas fa-caret-down" />;
      return <span className="oil-stat-card__dash">—</span>;
   };

   const expiration_colums = [
      {
         name: "Vehicle No",
         selector: (row) => row.vehicle?.vehicle_no,
         cell: (row) => row.vehicle?.vehicle_no || "—",
         sortable: true,
         grow: 1.1,
      },
      {
         name: "Expiring Documents",
         cell: (row) => {
            const docs = Object.entries(row.expiring_documents || {});
            if (!docs.length) return "—";
            return (
               <div className="oil-doc-badges">
                  {docs.map(([doc], index) => (
                     <span
                        key={`${doc}-${index}`}
                        className={`oil-doc-badge oil-doc-badge--${getDocBadgeTone(doc)}`}
                     >
                        {doc}
                     </span>
                  ))}
               </div>
            );
         },
         sortable: false,
         grow: 1.6,
      },
      {
         name: "Expiry Date",
         cell: (row) => {
            const docs = Object.entries(row.expiring_documents || {});
            if (!docs.length) return "—";
            return (
               <div className="oil-expiry-dates">
                  {docs.map(([doc, date], index) => (
                     <span key={`${doc}-${index}`} className="oil-expiry-dates__item">
                        {formatDisplayDate(date)}
                     </span>
                  ))}
               </div>
            );
         },
         sortable: false,
         grow: 1.1,
      },
      {
         name: "Driver",
         selector: (row) => row?.driver_name,
         cell: (row) => row?.driver_name || "-",
         sortable: true,
      },
      {
         name: "Location",
         selector: (row) => row?.attach_location,
         cell: (row) => row?.attach_location || "-",
         sortable: true,
      },
      {
         name: "Action",
         omit: role_id !== ROLES.corporateAdmin,
         cell: (row) => (
            <button
               type="button"
               className="oil-action-btn"
               title="View"
               onClick={() => navigate(`/fleet-master/view/${row?.vehicle?.id}`)}
            >
               <BsFillEyeFill />
            </button>
         ),
         width: "90px",
         center: true,
      },
   ];

   const current_trip_colums = [
      {
         name: "Customer",
         selector: (row) => row?.customer_name,
         cell: (row) => (
            <span title={row?.customer_name || ""}>
               {truncateText(row?.customer_name, 15)}
            </span>
         ),
         sortable: true,
         grow: 1.2,
      },
      {
         name: "Source",
         selector: (row) => row?.source,
         cell: (row) => (
            <span title={row?.source || ""}>{truncateText(row?.source, 14)}</span>
         ),
         sortable: true,
      },
      {
         name: "Destination",
         selector: (row) => row?.destination,
         cell: (row) => (
            <span title={row?.destination || ""}>
               {truncateText(row?.destination, 12)}
            </span>
         ),
         sortable: true,
      },
      {
         name: "Vehicle No",
         selector: (row) => row?.vehicle_no,
         cell: (row) => row?.vehicle_no || "—",
         sortable: true,
         grow: 1.1,
      },
      {
         name: "Driver",
         selector: (row) => row?.driver_name,
         cell: (row) => (
            <span title={row?.driver_name || ""}>
               {truncateText(row?.driver_name, 12)}
            </span>
         ),
         sortable: true,
      },
      {
         name: "Start Date",
         selector: (row) => row?.start_date,
         cell: (row) => formatDisplayDate(row?.start_date),
         sortable: true,
         grow: 1.1,
      },
   ];

   const unassigned_trip_vehicles_columns = [
      {
         name: "Vehicle No",
         selector: (row) => row?.vehicle_no,
         cell: (row) => row?.vehicle_no || "—",
         sortable: true,
      },
      {
         name: "Driver",
         selector: (row) => row?.driver_name,
         cell: (row) => (
            <span title={row?.driver_name || ""}>
               {row?.driver_name ? truncateText(row.driver_name, 16) : "—"}
            </span>
         ),
         sortable: true,
      },
      {
         name: "Attach Location",
         selector: (row) => row?.attached_location,
         cell: (row) => (
            <span title={row?.attached_location || ""}>
               {truncateText(row?.attached_location, 16)}
            </span>
         ),
         sortable: true,
      },
   ];

   return (
      <div className="oil-dashboard">
         <div className="container-fluid">
            <div className="row oil-stat-row">
               <div className="col-xl-3 col-md-6 col-12">
                  <a
                     href={`/trip/contractual/view/?review_status=pending`}
                     className="oil-stat-card oil-stat-card--blue"
                  >
                     <div className="oil-stat-card__icon">
                        <i className="fas fa-truck" />
                     </div>
                     <div className="oil-stat-card__body">
                        <div className="oil-stat-card__value">
                           {reportData?.trip_approval_pending ?? reportData?.pending_trips ?? 0}
                        </div>
                        <div className="oil-stat-card__label">Trip Approval Pending</div>
                        <div className={`oil-stat-card__trend ${getTrendClass(reportData?.last_week_percentage_change?.trip_approval_pending?.change_type)}`}>
                           {getTrendIcon(reportData?.last_week_percentage_change?.trip_approval_pending?.change_type)}
                           <span>
                              {reportData?.last_week_percentage_change?.trip_approval_pending?.percentage_change ?? reportData?.trip_approval_pending_change_percentage ?? 0}
                              {" % from last week"}
                           </span>
                        </div>
                     </div>
                  </a>
               </div>

               <div className="col-xl-3 col-md-6 col-12">
                  <a
                     href={`/trip/contractual/view/?trip_status=&review_status=&page=0&search=${todayDate}`}
                     className="oil-stat-card oil-stat-card--green"
                  >
                     <div className="oil-stat-card__icon">
                        <i className="fas fa-map-marker-alt" />
                     </div>
                     <div className="oil-stat-card__body">
                        <div className="oil-stat-card__value">
                           {reportData?.today_dispatch_trip ?? (Number(reportData?.dispatched_today_trips || 0) + Number(reportData?.dispatched_today_adhoc_trips || 0))}
                        </div>
                        <div className="oil-stat-card__label">
                           Today's Dispatched Trip
                        </div>
                     </div>
                  </a>
               </div>

               <div className="col-xl-3 col-md-6 col-12">
                  <a
                     href={`/trip/contractual/view/?trip_status=open`}
                     className="oil-stat-card oil-stat-card--orange"
                  >
                     <div className="oil-stat-card__icon">
                        <i className="fas fa-paper-plane" />
                     </div>
                     <div className="oil-stat-card__body">
                        <div className="oil-stat-card__value">
                           {reportData?.open_contractual_trips ?? reportData?.open_trips ?? 0}
                        </div>
                        <div className="oil-stat-card__label">Open Trips</div>
                        <div className={`oil-stat-card__trend ${getTrendClass(reportData?.last_week_percentage_change?.open_contractual_trips?.change_type)}`}>
                           {getTrendIcon(reportData?.last_week_percentage_change?.open_contractual_trips?.change_type)}
                           <span>
                              {reportData?.last_week_percentage_change?.open_contractual_trips?.percentage_change ?? reportData?.open_contractual_trips_change_percentage ?? 0}
                              {" % from last week"}
                           </span>
                        </div>
                     </div>
                  </a>
               </div>

               <div className="col-xl-3 col-md-6 col-12">
                  <a
                     href={`/fleet-master/list`}
                     className="oil-stat-card oil-stat-card--purple"
                  >
                     <div className="oil-stat-card__icon">
                        <i className="fas fa-users" />
                     </div>
                     <div className="oil-stat-card__body">
                        <div className="oil-stat-card__value">
                           {reportData?.total_vehicle ??
                              reportData?.total_vehicles ??
                              reportData?.total_fleets ??
                              reportData?.vehicles ??
                              0}
                        </div>
                        <div className="oil-stat-card__label">Total Vehicles</div>
                        <div className={`oil-stat-card__trend ${getTrendClass(reportData?.last_week_percentage_change?.total_vehicle?.change_type)}`}>
                           {getTrendIcon(reportData?.last_week_percentage_change?.total_vehicle?.change_type)}
                           <span>
                              {reportData?.last_week_percentage_change?.total_vehicle?.percentage_change ?? reportData?.total_vehicle_change_percentage ?? 0}
                              {" % from last week"}
                           </span>
                        </div>
                     </div>
                  </a>
               </div>
            </div>

            <DashboardTripCharts
               tripOverview={reportData?.overview_chart}
               tripStatus={reportData?.trip_status_report}
               range={range}
               setRange={setRange}
            />

            <div className="row">
               {(ROLES.corporateAdmin === role_id || ROLES.management === role_id) && (
                  <>
                     <div className="col-xl-7 col-lg-12 oil-table-panel-col">
                        <div className="oil-panel oil-table-panel">
                           <div className="oil-panel__header">
                              <h3 className="oil-panel__title">Current Trip (Open)</h3>
                              <a
                                 href="/trip/contractual/view/?trip_status=open"
                                 className="oil-panel__link"
                              >
                                 View All
                              </a>
                           </div>
                           <div className="oil-table-panel__body">
                              <CustomTable
                                 columns={current_trip_colums}
                                 data={currentOpenTrip.slice(0, 5)}
                                 pagination={false}
                                 theme="oil"
                              />
                           </div>
                        </div>
                     </div>

                     <div className="col-xl-5 col-lg-12 oil-table-panel-col">
                        <div className="oil-panel oil-table-panel">
                           <div className="oil-panel__header">
                              <h3 className="oil-panel__title">
                                 Unassigned Trip Vehicles
                              </h3>
                              {/* <a href="/fleet-master/list" className="oil-panel__link">
                                 View All
                              </a> */}
                           </div>
                           <div className="oil-table-panel__body">
                              <CustomTable
                                 columns={unassigned_trip_vehicles_columns}
                                 data={unassignedTripRecords.slice(0, 5)}
                                 pagination={false}
                                 theme="oil"
                              />
                           </div>
                        </div>
                     </div>
                     {(ROLES.corporateAdmin === role_id) && (
                     <div className="col-12 oil-table-panel-col">
                        <div className="oil-panel oil-table-panel">
                           <div className="oil-panel__header">
                              <h3 className="oil-panel__title">Expiration Reminders</h3>
                              {/* <a href="/fleet-master/list" className="oil-panel__link">
                                 View All
                              </a> */}
                           </div>
                           <div className="oil-table-panel__body">
                              <CustomTable
                                 columns={expiration_colums}
                                 data={expiration_records.slice(0, 5)}
                                 pagination={false}
                                 theme="oil"
                              />
                           </div>
                        </div>
                     </div>
                     )}
                  </>
               )}
            </div>

            {(ROLES.corporateAdmin === role_id) && (
               <DashboardAnalyticsPanels 
                  fleetDistribution={reportData?.fleet_distribution}
                  topLocations={reportData?.top_locations}
                  emiData={emiData}
               />
            )}

            {/* legacy commented dashboard widgets kept below */}
            <div className="row d-none">
               {/* <section className="col-lg-12 connectedSortable">
                  <div className="card">
                     <div className="card-header">
                        <h3 className="card-title">
                           <i className="fas fa-chart-pie mr-1" />
                           Sales
                        </h3>
                        <div className="card-tools">
                           <ul className="nav nav-pills ml-auto">
                              <li className="nav-item">
                                 <a
                                    className="nav-link active"
                                    href="#revenue-chart"
                                    data-toggle="tab"
                                 >
                                    Area
                                 </a>
                              </li>
                              <li className="nav-item">
                                 <a
                                    className="nav-link"
                                    href="#sales-chart"
                                    data-toggle="tab"
                                 >
                                    Donut
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                     <div className="card-body">
                        <div className="tab-content p-0">
                           <div
                              className="chart tab-pane active"
                              id="revenue-chart"
                              style={{ position: "relative", height: 300 }}
                           >
                              <AreaChart />
                           </div>
                           <div
                              className="chart tab-pane"
                              id="sales-chart"
                              style={{ position: "relative", height: 300 }}
                           >
                              <canvas
                                 id="sales-chart-canvas"
                                 height={300}
                                 style={{ height: 300 }}
                              />
                           </div>
                        </div>
                     </div>
                  </div>
               </section> */}

               {/* <section className="col-lg-7 connectedSortable">
                  <div className="card">
                     <div className="card-header">
                        <h3 className="card-title">
                           <i className="ion ion-clipboard mr-1" />
                           To Do List
                        </h3>
                        <div className="card-tools">
                           <ul className="pagination pagination-sm">
                              <li className="page-item">
                                 <a href="#" className="page-link">
                                    «
                                 </a>
                              </li>
                              <li className="page-item">
                                 <a href="#" className="page-link">
                                    1
                                 </a>
                              </li>
                              <li className="page-item">
                                 <a href="#" className="page-link">
                                    2
                                 </a>
                              </li>
                              <li className="page-item">
                                 <a href="#" className="page-link">
                                    3
                                 </a>
                              </li>
                              <li className="page-item">
                                 <a href="#" className="page-link">
                                    »
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                     <div className="card-body">
                        <ul className="todo-list" data-widget="todo-list">
                           <li>
                              <span className="handle">
                                 <i className="fas fa-ellipsis-v" />
                                 <i className="fas fa-ellipsis-v" />
                              </span>
                              <div className="icheck-primary d-inline ml-2">
                                 <input
                                    type="checkbox"
                                    defaultValue
                                    name="todo1"
                                    id="todoCheck1"
                                 />
                                 <label htmlFor="todoCheck1" />
                              </div>
                              <span className="text">Design a nice theme</span>
                              <small className="badge badge-danger">
                                 <i className="far fa-clock" /> 2 mins
                              </small>
                              <div className="tools">
                                 <i className="fas fa-edit" />
                                 <i className="fas fa-trash-o" />
                              </div>
                           </li>
                           <li>
                              <span className="handle">
                                 <i className="fas fa-ellipsis-v" />
                                 <i className="fas fa-ellipsis-v" />
                              </span>
                              <div className="icheck-primary d-inline ml-2">
                                 <input
                                    type="checkbox"
                                    defaultValue
                                    name="todo2"
                                    id="todoCheck2"
                                    defaultChecked
                                 />
                                 <label htmlFor="todoCheck2" />
                              </div>
                              <span className="text">Make the theme responsive</span>
                              <small className="badge badge-info">
                                 <i className="far fa-clock" /> 4 hours
                              </small>
                              <div className="tools">
                                 <i className="fas fa-edit" />
                                 <i className="fas fa-trash-o" />
                              </div>
                           </li>
                           <li>
                              <span className="handle">
                                 <i className="fas fa-ellipsis-v" />
                                 <i className="fas fa-ellipsis-v" />
                              </span>
                              <div className="icheck-primary d-inline ml-2">
                                 <input
                                    type="checkbox"
                                    defaultValue
                                    name="todo3"
                                    id="todoCheck3"
                                 />
                                 <label htmlFor="todoCheck3" />
                              </div>
                              <span className="text">Let theme shine like a star</span>
                              <small className="badge badge-warning">
                                 <i className="far fa-clock" /> 1 day
                              </small>
                              <div className="tools">
                                 <i className="fas fa-edit" />
                                 <i className="fas fa-trash-o" />
                              </div>
                           </li>
                           <li>
                              <span className="handle">
                                 <i className="fas fa-ellipsis-v" />
                                 <i className="fas fa-ellipsis-v" />
                              </span>
                              <div className="icheck-primary d-inline ml-2">
                                 <input
                                    type="checkbox"
                                    defaultValue
                                    name="todo4"
                                    id="todoCheck4"
                                 />
                                 <label htmlFor="todoCheck4" />
                              </div>
                              <span className="text">Let theme shine like a star</span>
                              <small className="badge badge-success">
                                 <i className="far fa-clock" /> 3 days
                              </small>
                              <div className="tools">
                                 <i className="fas fa-edit" />
                                 <i className="fas fa-trash-o" />
                              </div>
                           </li>
                           <li>
                              <span className="handle">
                                 <i className="fas fa-ellipsis-v" />
                                 <i className="fas fa-ellipsis-v" />
                              </span>
                              <div className="icheck-primary d-inline ml-2">
                                 <input
                                    type="checkbox"
                                    defaultValue
                                    name="todo5"
                                    id="todoCheck5"
                                 />
                                 <label htmlFor="todoCheck5" />
                              </div>
                              <span className="text">
                                 Check your messages and notifications
                              </span>
                              <small className="badge badge-primary">
                                 <i className="far fa-clock" /> 1 week
                              </small>
                              <div className="tools">
                                 <i className="fas fa-edit" />
                                 <i className="fas fa-trash-o" />
                              </div>
                           </li>
                           <li>
                              <span className="handle">
                                 <i className="fas fa-ellipsis-v" />
                                 <i className="fas fa-ellipsis-v" />
                              </span>
                              <div className="icheck-primary d-inline ml-2">
                                 <input
                                    type="checkbox"
                                    defaultValue
                                    name="todo6"
                                    id="todoCheck6"
                                 />
                                 <label htmlFor="todoCheck6" />
                              </div>
                              <span className="text">Let theme shine like a star</span>
                              <small className="badge badge-secondary">
                                 <i className="far fa-clock" /> 1 month
                              </small>
                              <div className="tools">
                                 <i className="fas fa-edit" />
                                 <i className="fas fa-trash-o" />
                              </div>
                           </li>
                        </ul>
                     </div>
                     <div className="card-footer clearfix">
                        <button type="button" className="btn btn-primary float-right">
                           <i className="fas fa-plus" /> Add item
                        </button>
                     </div>
                  </div>
               </section> */}
               {/* <section className="col-lg-5 connectedSortable">
                  <div className="card bg-gradient-info">
                     <div className="card-header border-0">
                        <h3 className="card-title">
                           <i className="fas fa-th mr-1" />
                           Sales Graph
                        </h3>
                        <div className="card-tools">
                           <button
                              type="button"
                              className="btn bg-info btn-sm"
                              data-card-widget="collapse"
                           >
                              <i className="fas fa-minus" />
                           </button>
                           <button
                              type="button"
                              className="btn bg-info btn-sm"
                              data-card-widget="remove"
                           >
                              <i className="fas fa-times" />
                           </button>
                        </div>
                     </div>
                     <div className="card-body">
                        <canvas
                           className="chart"
                           id="line-chart"
                           style={{
                              minHeight: 250,
                              height: 250,
                              maxHeight: 250,
                              maxWidth: "100%",
                           }}
                        />
                     </div>
                     <div className="card-footer bg-transparent">
                        <div className="row">
                           <div className="col-4 text-center">
                              <input
                                 type="text"
                                 className="knob"
                                 data-readonly="true"
                                 defaultValue={20}
                                 data-width={60}
                                 data-height={60}
                                 data-fgcolor="#39CCCC"
                              />
                              <div className="text-white">Mail-Orders</div>
                           </div>
                           <div className="col-4 text-center">
                              <input
                                 type="text"
                                 className="knob"
                                 data-readonly="true"
                                 defaultValue={50}
                                 data-width={60}
                                 data-height={60}
                                 data-fgcolor="#39CCCC"
                              />
                              <div className="text-white">Online</div>
                           </div>
                           <div className="col-4 text-center">
                              <input
                                 type="text"
                                 className="knob"
                                 data-readonly="true"
                                 defaultValue={30}
                                 data-width={60}
                                 data-height={60}
                                 data-fgcolor="#39CCCC"
                              />
                              <div className="text-white">In-Store</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </section> */}
            </div>
         </div>
         <div className="container-fluid"></div>
      </div>
   );
};

export default Body;
